export default __webpack_public_path__ + "static/media/navlogo.4da001e3.svg";